import * as Types from '../../../../__generated__/types';

import { gql } from '@apollo/client';
import { StatusListFragmentDoc } from '../../StatusList/__generated__/StatusList.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetStatusByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type GetStatusByIdQuery = { __typename?: 'Query', getStatusById: { __typename?: 'Status', id: string, title: string, type: Types.StatusType } };


export const GetStatusByIdDocument = gql`
    query getStatusById($id: ID!) {
  getStatusById(id: $id) {
    ...StatusList
  }
}
    ${StatusListFragmentDoc}`;

/**
 * __useGetStatusByIdQuery__
 *
 * To run a query within a React component, call `useGetStatusByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatusByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatusByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStatusByIdQuery(baseOptions: Apollo.QueryHookOptions<GetStatusByIdQuery, GetStatusByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatusByIdQuery, GetStatusByIdQueryVariables>(GetStatusByIdDocument, options);
      }
export function useGetStatusByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatusByIdQuery, GetStatusByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatusByIdQuery, GetStatusByIdQueryVariables>(GetStatusByIdDocument, options);
        }
export type GetStatusByIdQueryHookResult = ReturnType<typeof useGetStatusByIdQuery>;
export type GetStatusByIdLazyQueryHookResult = ReturnType<typeof useGetStatusByIdLazyQuery>;
export type GetStatusByIdQueryResult = Apollo.QueryResult<GetStatusByIdQuery, GetStatusByIdQueryVariables>;